import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function WaitlistForm({ productId }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/waitlist", { product_id: productId, email });
      setDone(true);
      toast.success(data.already ? "Kamu sudah terdaftar" : "Berhasil masuk waitlist");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gagal");
    } finally { setBusy(false); }
  };
  if (done) {
    return (
      <div data-testid="waitlist-done" className="mt-8 border border-[color:var(--border)] p-4 text-sm">
        <div className="text-[10px] tracking-widest text-neutral-500 mb-1">TERDAFTAR</div>
        Kami akan mengirim email begitu drop ini rilis.
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="mt-8 border border-[color:var(--border)] p-4">
      <div className="text-[10px] tracking-widest text-neutral-500 mb-2">NOTIFIKASI DROP</div>
      <p className="text-neutral-400 text-sm mb-3">Masukkan email — kami akan kabari kamu begitu produk ini rilis.</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input data-testid="waitlist-email" required type="email" placeholder="email@kamu.com" className="flex-1 bg-transparent border border-[color:var(--border)] p-3 text-sm focus:border-white outline-none" value={email} onChange={(e) => setEmail(e.target.value)} />
        <button data-testid="waitlist-submit" disabled={busy} className="bg-white text-black px-6 py-3 text-xs tracking-widest disabled:opacity-60">{busy ? "..." : "NOTIFIKASI SAYA"}</button>
      </div>
    </form>
  );
}
